import { merge } from "lodash-es";
import actions from "./actions";

const state = {
  topicInfo: {
    id: "",
    pic: "",
    name: "",
    info: "",
    hot_point: '0', // 热度; 破万要显示XX万
    read: 0, // 阅读数
    replies: 0, // 评论数
    thread: 0, // 帖子数
    follow_status: 0, // 关注状态，1=已关注，0=未关注(未登录状态一律未关注)
  },
  topicPostListData: {
    list: [],
    pageSize: 20, // 一页几笔
    total: 0, // 总笔数
    page: 1, // 第几页
    pages: 1, // 总页数
  },
};

const getters = {};

const mutations = {
  setTopicInfo(state, data) {
    state.topicInfo = { ...state.topicInfo, ...data };
  },
  setTopicPostListData(state, data) {
    state.topicPostListData = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
